import Evaluation from '../complex/evaluation';
import Perceivable from '../complex/perceivable';
import TextAlternatives from '../complex/textAlternatives';
import NonTextContent from '../complex/nonTextContent';
import TimeBasedMedia from '../complex/timeBasedMedia';
import Adaptable from '../complex/adaptable';
import Relationships from '../complex/relationships';
import Sequence from '../complex/sequence';
import SensoryCharacteristics from '../complex/sensoryCharacteristics';
import IdentifyPurpose from '../complex/identifyPurpose';
import Distinguishable from '../complex/distinguishable';
import Operable from '../complex/operable';
import Keyboard from '../complex/keyboard';
import EnoughTime from '../complex/enoughTime';
import AutomaticUpdates from '../complex/automaticUpdates';
import Seizures from '../complex/seizures';
import Navigable from '../complex/navigable';
import Title from '../complex/title';
import FocusOrder from '../complex/focusOrder';
import LinkContext from '../complex/linkContext';
import HeadingsAndLabels from '../complex/headingsAndLabels';
import FocusVisible from '../complex/focusVisible';
import SectionHeadings from '../complex/sectionHeadings';
import InputModalities from '../complex/inputModalities';
import LabelInName from '../complex/labelInName';
import Understandable from '../complex/understandable';
import Readable from '../complex/readable';
import LanguageOfPage from '../complex/languageOfPage';
import LanguageOfParts from '../complex/languageOfParts';
import Predictable from '../complex/predictable';
import OnInput from '../complex/onInput';
import InputAssistance from '../complex/inputAssistance';
import Robust from '../complex/robust';
import Compatible from '../complex/compatible';
import StatusMessages from '../complex/statusMessages';

const Main = () => {
	return (
	<>
		<main>
		<Evaluation />
		<Perceivable />
		<TextAlternatives />
		<NonTextContent />
		<TimeBasedMedia />
		<Adaptable />
		<Relationships />
		<Sequence />
		<SensoryCharacteristics />
		<IdentifyPurpose />
		<Distinguishable />
		<Operable />
		<Keyboard />
		<EnoughTime />
		<AutomaticUpdates />
		<Seizures />
		<Navigable />
		<Title />
		<FocusOrder />
		<LinkContext />
		<HeadingsAndLabels />
		<FocusVisible />
		<SectionHeadings />
		<InputModalities />
		<LabelInName />
		<Understandable />
		<Readable />
		<LanguageOfPage />
		<LanguageOfParts />
		<Predictable />
		<OnInput />
		<InputAssistance />
		<Robust />
		<Compatible />
		<StatusMessages />
		</main>
		</>
	);
}

export default Main;
